<template xmlns="http://www.w3.org/1999/html">
 
    <div style="width: 100vw;height: 100vh;display: flex;flex-direction: column;">
      <div
        style="width: 100vw;height: 6vh;background-color: rgb(52,31,18);display: flex;align-items: center;justify-content: center;">
        <img src="/static/images/jiuzan/usercenter.png"
          style="width: 19vw;display: block;" />
      </div>
      
      <div id="bannerbg"
        style="width: 100vw;height: 26vh;background: url(/static/images/jiuzan/bannerbg.png) center center / cover no-repeat;display: flex;flex-direction: column;align-items: center;">
        <img src="/static/images/jiuzan/logo.png" style="width: 30vw;display: block;margin-top: 2vh;" />
        <img src="/static/images/jiuzan/city.png" style="width: 70vw;display: block;margin-top: 1vh;" />
      </div>
      
      <div id="scan" style="width: 100vw;display: flex;justify-content: center;align-items: center;flex-direction: column;">
        <img @click="openScan" src="/static/images/jiuzan/scan.png" style="width: 35vw;display: block;margin-top: 7vh;" />
        <img src="/static/images/jiuzan/tip.png" style="width: 50vw;display: block;margin-top: 4vh;" />
      </div>
      
      <div style="width: 100vw;display: flex;justify-content: center;align-items: center;margin-top: 6vh;position: relative;">
        <div style="width: 100vw;height: auto;display: flex;justify-content: center;align-items: center;padding: 3vh 5vw;">
          <div style="display: flex;width: 76vw;border-radius: 8px;overflow: hidden;box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
            <input type="text" v-model="antiCode" placeholder="输入16位数码" maxlength="16"
              style="flex: 1;height: 6vh;border: 2px solid rgb(29,30,32);border-right: none;border-radius: 8px 0 0 8px;padding: 0 3vw;font-size: 4vw;background: white;color: #333;outline: none;" />
            <button @click="queryAnti"
              style="width: 20vw;height: 6vh;background: linear-gradient(to right, rgb(120,80,50), rgb(52,31,18));color: white;border: none;border-radius: 0 8px 8px 0;font-size: 4.5vw;font-weight: bold;cursor: pointer;outline: none;">
              查询
            </button>
          </div>
        </div>
      </div>
     


    </div>

</template>



<script>
import { getAntiData, getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      antiCode: "",
      eno: "138735818115",
    }
  },
  methods: {
    openScan() {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('/');
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : ''
            scanQRCode = scanQRCode.substring(0, 16)
          }
          this.antiCode = scanQRCode
          this.queryAnti()
        }
      })
    },
    queryAnti() {
      if (this.antiCode == '' || this.antiCode.length != 16) {
        alert("请输入16位防伪码进行查询验证")
      } else {
        this.$router.push({
          path: '/jz.query',
          query: {
            c: this.antiCode
          }
        })
      }
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wx7e8df2f40063c010").then(res => {
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseimg',
            'predivimg',
            'uploadimg',
            'downloadimg',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificdiv',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  mounted: function () {
    this.getWxJs()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/JiuZan/Index.vue